"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnableTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "burner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Burn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610352806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c806318160ddd1461005157806342966c681461006b57806370a082311461008a578063a9059cbb146100b0575b600080fd5b6100596100f0565b60408051918252519081900360200190f35b6100886004803603602081101561008157600080fd5b50356100f6565b005b610059600480360360208110156100a057600080fd5b50356001600160a01b0316610103565b6100dc600480360360408110156100c657600080fd5b506001600160a01b03813516906020013561011e565b604080519115158252519081900360200190f35b60015490565b61010033826101e9565b50565b6001600160a01b031660009081526020819052604090205490565b3360009081526020819052604081205482111561013a57600080fd5b6001600160a01b03831661014d57600080fd5b3360009081526020819052604090205461016d908363ffffffff6102d816565b33600090815260208190526040808220929092556001600160a01b0385168152205461019f908363ffffffff6102ea16565b6001600160a01b038416600081815260208181526040918290209390935580518581529051919233926000805160206102fe8339815191529281900390910190a350600192915050565b6001600160a01b03821660009081526020819052604090205481111561020e57600080fd5b6001600160a01b038216600090815260208190526040902054610237908263ffffffff6102d816565b6001600160a01b038316600090815260208190526040902055600154610263908263ffffffff6102d816565b6001556040805182815290516001600160a01b038416917fcc16f5dbb4873280815c1ee09dbd06736cffcc184412cf7a71a0fdb75d397ca5919081900360200190a26040805182815290516000916001600160a01b038516916000805160206102fe8339815191529181900360200190a35050565b6000828211156102e457fe5b50900390565b818101828110156102f757fe5b9291505056feddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3efa265627a7a72315820f99093d8be2dca160f110692c08864a6244eeea348499717d2e685f94a5bd4fa64736f6c63430005100032";
class BurnableTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BurnableTokenFactory = BurnableTokenFactory;
BurnableTokenFactory.bytecode = _bytecode;
BurnableTokenFactory.abi = _abi;
//# sourceMappingURL=BurnableTokenFactory.js.map